import { render } from "./SelecionarConta.vue?vue&type=template&id=4db9c79e&scoped=true&ts=true"
import script from "./SelecionarConta.vue?vue&type=script&lang=ts"
export * from "./SelecionarConta.vue?vue&type=script&lang=ts"

import "./SelecionarConta.vue?vue&type=style&index=0&id=4db9c79e&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4db9c79e"]])

export default __exports__